import { merge } from 'lodash';

export function getSortOrder(newOrderBy, { order, orderBy }) {
    if (newOrderBy !== orderBy || order === 'desc') {
        return 'asc';
    } else  {
        return 'desc';
    }
}

/**
 * Returns a new copy of the collection that contains the a copy
 * of the specified item with the provided patch applied.
 *
 * `patch` can be an object, or a function that returns an object, to
 * that is then merged into the specified `item`.
 *
 * If the item is not found, the original collection reference is
 * returned.
 */
export function patchItem(collection, itemId, patch) {
    let index = collection.findIndex(
        ({ id }) => id === itemId
    );
    if (index === -1) {
        return collection;
    }
    const items = [...collection];
    const item = items[index];
    if (typeof patch === 'function') {
        patch = patch(item, collection);
    }
    const updatedItem = merge({}, item, patch);
    items.splice(index, 1, updatedItem);
    return items;
}

/**
 * Returns a new copy of the collection without the specified item,
 * identified by its ID.
 */
export function removeItem(collection, itemId) {
    return collection.filter(({ id }) => id !== itemId);
}
